export const SPORTS_BET_TYPES = {
    SINGLE: "SingleBet",
    COMBO: "ComboBet",
    SYSTEM: "SystemBet",
};